import { Component, output } from "@angular/core";
import { ButtonComponent } from "@odx/angular/components/button";
import { IconComponent } from "@odx/angular/components/icon";

@Component({
  selector: "app-reset-button",
  imports: [ButtonComponent, IconComponent],
  templateUrl: "./reset-button.component.html",
  styleUrl: "./reset-button.component.scss",
})
export class ResetButtonComponent {
  readonly resetButtonClicked = output<void>();
}
